import React from 'react';
import { Outlet } from 'react-router-dom';
import AccessDeniedCard from './AccessDeniedCard';
import { usePermissions } from '../hooks/usePermissions';

/**
 * Route gate for DEVELOPER_DASHBOARD permissions (same pattern as einvoicing EInvoiceAccessLayout).
 * Pass `permission` (single) or `permissions` (any-of) and a title for AccessDeniedCard.
 */
export default function WebhooksAccessLayout({ title, permission, permissions }) {
  const { loading, hasWebhookPermission } = usePermissions();

  if (loading) {
    return null;
  }

  const isAllowed = permissions
    ? permissions.some((code) => hasWebhookPermission(code))
    : hasWebhookPermission(permission);

  if (!isAllowed) {
    return <AccessDeniedCard title={title} />;
  }

  return <Outlet />;
}
